import { render, staticRenderFns } from "./GF.vue?vue&type=template&id=5f2a1a64&scoped=true&"
import script from "./GF.vue?vue&type=script&lang=js&"
export * from "./GF.vue?vue&type=script&lang=js&"
import style0 from "./GF.vue?vue&type=style&index=0&id=5f2a1a64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a1a64",
  null
  
)

export default component.exports